import React from 'react';
import { Link } from 'react-router-dom';
import './style/MoreOptions.css';

import {
  ShieldCheck,
  Info,
  Mail,
  ListChecks,
  BarChart3,
  FileText,
  RefreshCw,
  Truck
} from 'lucide-react';

import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';

const MoreOptions = () => {
  const options = [
    { id: 1, title: 'About Us', icon: <Info size={24} />, color: '#7f8c8d', path: '/about' },
    { id: 2, title: 'Contact Us', icon: <Mail size={24} />, color: '#1abc9c', path: '/contact' },
    { id: 3, title: 'Privacy Policy', icon: <ShieldCheck size={24} />, color: '#27ae60', path: '/privacy-policy' },
    { id: 4, title: 'Terms and Conditions', icon: <FileText size={24} />, color: '#27ae60', path: '/terms-conditions' },
    { id: 5, title: 'Refund Policy', icon: <RefreshCw size={24} />, color: '#27ae60', path: '/refund-policy' },
    // { id: 8, title: 'Shipping Policy', icon: <Truck size={24} />, color: '#27ae60', path: '/shipping-policy' },

  ];



 







  return (
    <div className="more-options-container">
      <TopNavbar name="More Options" />
      <TopHeader name="More Options" />
     
      <div className="options-grid">
        {options.map((option) => (
          <Link to={option.path} key={option.id} className="option-link-wrapper">
            <div className="option-card">
              <div className="icon-wrapper" style={{ color: option.color }}>
                {option.icon}
              </div>
              <span className="option-title">{option.title}</span>
            </div>

          </Link>


        ))}    <br></br><br></br>
      </div>




    </div>
  );
};

export default MoreOptions;